import { ButtonCopy, Typography } from 'shared/ui'
import { CDN_FRONT } from 'shared/config'
import { type EntitiesStore } from 'entities/EntitiesExport'
import styles from './styles.module.scss'

export const CopySnippetModal = ({ entities }: { entities: EntitiesStore }) => {
  const { organizationStore } = entities
  const scriptUrl = document.createElement('script')
  scriptUrl.type = 'text/javascript'
  scriptUrl.src = `https://${CDN_FRONT}/js/combine-${organizationStore.hashId}.js`

  const scriptChat = scriptUrl.outerHTML
  const script =
    '<!-- Start of Salesmsg Embed Code -->' +
    '\n' +
    scriptChat +
    '\n' +
    '<!-- End of Salesmsg Embed Code -->'

  return (
    <div className={styles.copyWrapper}>
      <Typography
        ariaLabel='ScriptTitle'
        variant='body-md-medium'
        color='var(--content-primary-primary)'
        marginBottom={4}
      >
        JavaScript Code
      </Typography>
      <Typography
        ariaLabel='ScriptDescription'
        variant='body-md-regular'
        color='var(--content-primary-tertiary)'
      >
        {
          'Copy and paste this tracking code into every page of your site, just before the </body> tag.'
        }
      </Typography>
      <div className={styles.copyBlock}>
        <Typography
          ariaLabel='script'
          variant='body-rg-regular'
          color='var(--content-primary-secondary)'
          className={styles.script}
        >
          {script}
        </Typography>

        <ButtonCopy value={script} buttonProps={{ size: 'medium' }} />
      </div>
    </div>
  )
}
